var map = {
	"./Colors4x4.png": 49764,
	"./Colors64x64.png": 13772,
	"./Creeper.png": 34402,
	"./GrassSide.png": 89829,
	"./GrassTop.png": 4764,
	"./Steve-Corners.png": 78610,
	"./Steve-Faces.png": 65969,
	"./Steve.png": 37643,
	"./Steve256.png": 93990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10403;